/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Swap_By_TomorrowInputs */

const en_po_issue_swap_by_tomorrow = /** @type {(inputs: Po_Issue_Swap_By_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is a swap of SKU, which Tomorrow proposes for the supplier`)
};

/**
* | output |
* | --- |
* | "is a swap of SKU, which Tomorrow proposes for the supplier" |
*
* @param {Po_Issue_Swap_By_TomorrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_swap_by_tomorrow = /** @type {((inputs?: Po_Issue_Swap_By_TomorrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Swap_By_TomorrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_swap_by_tomorrow(inputs)
});